<template>
    <div id="logs">
        <div v-if="logs.length > 0" class="log">
            <h1>{{logs[logs.length - 1].message}}</h1>
        </div>
    </div>
</template>

<script>

import { EventBus } from '../Event'
import axios from 'axios'

export default {
  name: "Logs",
  data() {
    return {
        logs: [],
        logCount: 0
    }
  },
  created() {
    EventBus.$on('new_log', (message) => {
        this.logs.push( {id: this.logCount, message: message} );
        this.logCount += 1; 
    })
  },
}
</script>

<style scoped>
#logs {
  width:100%;
  position:fixed;
  top:0px;
  z-index: 5;
}

.log {
  color:black;
  color: black;
  font-size:2.5vw;
}
</style>
